import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import arrowIcon from '../../assets/icons/arrow_circle.svg'
import { EnviaEmail } from '../../components/FormSenha/envia-email'
import { ConfirmaEmail } from '../../components/FormSenha/confirma-email'
import { MudarSenha } from '../../components/FormSenha/mudar-senha'
import { useIsMutating, useMutation } from '@tanstack/react-query';
import { apiLogin } from '../../services/api'
import { ModalSucesso } from '../../components/Modal/components/sucesso';
import { ModalErro } from '../../components/Modal/components/erro';
import { useModal } from '../../hooks/ModalContext';
import { Loader } from '../../components/generics/loader';

interface ChangePassword {
  email: string;
  password: string;
}


export function RecuperacaoSenha() {
  const [isSentEmail, setIsSentEmail] = useState(false);
  const [isConfirmedEmail, setIsConfirmedEmail] = useState(false);
  const { setModal } = useModal()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')

  const isFetching = useIsMutating({ mutationKey: ['password'] })

  const mutationReset = useMutation({
    mutationFn: ({ email, password }: ChangePassword) => {
      return apiLogin.put('/reset-password', { email, password })
    },
    mutationKey: ['password'],
    onSuccess: () => {
      setModal('Senha alterada com sucesso!', 'Sucesso', true, false)
    },
    onError: () => setModal('ERRO ALTERAR SENHA', 'Erro', false, true)
  })

  const mutationEmail = useMutation({
    mutationFn: (email: string) => {
      return apiLogin.post('/request-reset', { email })
    },
    mutationKey: ['password'],

    onError: () => setModal('Não foi possível encontrar o email informado em nossa base de dados!', 'Erro', false, true)
  })

  const mutationCode = useMutation({
    mutationFn: ({ email, code }: { email: string, code: string }) => {
      return apiLogin.put('/verify-code', { email, code })
    },
    mutationKey: ['password'],
    onSuccess: () => {
      setIsConfirmedEmail(true)
      setIsSentEmail(true)
    },
    onError: () => setModal('Código inválido ou expirado!', 'Erro', false, true)
  })


  async function sendEmail(email: string) {
    await mutationEmail.mutateAsync(email)
    setEmail(email)
    if (mutationEmail.isSuccess) {
      setIsSentEmail(true)
    }
  }
  async function confirmEmail(code: string) {
    await mutationCode.mutateAsync({ email, code })
  }

  async function changePassword({ email, password }: ChangePassword) {
    await mutationReset.mutateAsync({ email, password })
  }

  function backPage() {
    if (!isSentEmail && !isConfirmedEmail) {
      navigate('/')
    } else if (!isConfirmedEmail && isSentEmail) {
      setIsSentEmail(false)
    } else {
      setIsSentEmail(false)
      setIsConfirmedEmail(false)
    }
  }

  return (
    <>
      <section>
        <div className="flex min-h-screen w-full items-center justify-center">
          <div className="flex h-[50%] flex-col p-8 border-2 rounded-lg shadow-lg">
            <button className='flex w-[15%]  items-center justify-between' onClick={() => backPage()}>
              <img src={arrowIcon} alt="" className='h-6 w-6' />
              <p className='font-semibold text-gray-600 mx-2 text-lg'>Voltar</p>
            </button>

            {!isSentEmail && !isConfirmedEmail && <EnviaEmail sendEmail={sendEmail} />}

            {!isConfirmedEmail && isSentEmail && <ConfirmaEmail confirmEmail={confirmEmail} email={email} />}

            {isConfirmedEmail && isSentEmail && <MudarSenha changePassword={changePassword} email={email} />}

          </div>
        </div>

        <ModalSucesso />
        <ModalErro />

        {(isFetching) && (<div className=" flex justify-center top-0 items-center h-full w-full absolute bg-white opacity-70 z-50 px-4 py-4  ">
          <Loader size={4} />
        </div>)}
      </section>
    </>
  )
}